import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿En qué formato se entrega el recetario?',
    a: 'El recetario y todos los bonos se entregan en formato digital (PDF). Podrás descargarlos inmediatamente después de tu compra y verlos en tu celular, tablet o computadora, o imprimirlos si lo preferís.'
  }, {
    q: '¿Cómo accedo a los libros después de pagar?',
    a: 'Una vez confirmado el pago, recibirás automáticamente un correo electrónico con los enlaces de descarga directa para acceder a todo el material al instante.'
  }, {
    q: '¿Necesito experiencia previa en repostería?',
    a: '¡Para nada! Este recetario está diseñado paso a paso para que cualquier persona, incluso si nunca ha horneado antes, pueda lograr resultados perfectos desde el primer intento.'
  }, {
    q: '¿Los ingredientes son fáciles de conseguir?',
    a: 'Sí, todas nuestras recetas utilizan ingredientes comunes que podés encontrar en cualquier supermercado o almacén de barrio. No usamos ingredientes raros ni costosos.'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Aceptamos todas las tarjetas de crédito y débito, además de métodos de pago locales dependiendo de tu país. Todo el proceso es 100% seguro y encriptado.'
  }, {
    q: '¿Cómo funciona la garantía de 45 días?',
    a: 'Si dentro de los 45 días posteriores a tu compra sentís que el recetario no es para vos, solo tenés que enviarnos un correo y te reembolsaremos el 100% de tu dinero, sin hacer preguntas.'
  }];
  return <section className="py-20 px-4 bg-[#FFF8F0]" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <h2 className="text-3xl md:text-4xl font-bold text-[#3C1518] text-center mb-12" data-id="element-47">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-[#E8D5C0] rounded-xl overflow-hidden transition-all duration-300" data-id="element-49">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-50">
                <span className="text-lg font-medium text-[#3C1518] pr-4" data-id="element-51">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#EA580C] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-52" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-53">
                <p className="text-[#5C2D0E] leading-relaxed" data-id="element-54">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}